export default __webpack_public_path__ + "img/4294c36af06efb2b45e01c1d113b7e5c.png";